@import '../../sass/helpers';

.accordions {
    border-radius: 2px;
    border: 1px solid $border-color;
    border-bottom:none;
}